module.exports = __webpack_public_path__ + "static/media/post-nutrition.d02a5d92.svg";